// extracted by mini-css-extract-plugin
export default {"LeftPane":"sgp-client-views--styles--LeftPane","MainContainer":"sgp-client-views--styles--MainContainer","MainPageArea":"sgp-client-views--styles--MainPageArea"};